const justifySelf = {
    name: "justify-self",
    path: "/justify-self",
    title: "justify-self",
    description: "Utilities for controlling how an individual grid item is aligned along its inline axis.",
    value: {
        "justify-self": {
            "justify-self-auto": "auto",
            "justify-self-start": "start",
            "justify-self-center": "center",
            "justify-self-center-safe": "safe center",
            "justify-self-end": "end",
            "justify-self-end-safe": "safe end",
            "justify-self-stretch": "stretch",
            "justify-self-normal": "normal",
        },
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="grid grid-columns-3 gap-4">
  <div class="bg-color-pink-500 text-white p-4 flex justify-center items-center">01</div>
  <div class="bg-color-pink-500 text-white p-4 flex justify-center items-center justify-self-start">02 (start)</div>
  <div class="bg-color-pink-500 text-white p-4 flex justify-center items-center">03</div>
</div>

<div class="grid grid-columns-3 gap-4 mt-6">
  <div class="bg-color-pink-500 text-white p-4">01</div>
  <div class="bg-color-pink-500 text-white p-4 justify-self-end">02 (end)</div>
  <div class="bg-color-pink-500 text-white p-4">03</div>
</div>

<div class="grid grid-columns-3 gap-4 mt-6">
  <div class="bg-color-pink-500 text-white p-4">01</div>
  <div class="bg-color-pink-500 text-white p-4 justify-self-center">02 (center)</div>
  <div class="bg-color-pink-500 text-white p-4">03</div>
</div>

<div class="grid grid-columns-3 gap-4 mt-6">
  <div class="bg-color-pink-500 text-white p-4">01</div>
  <div class="bg-color-pink-500 text-white p-4 justify-self-stretch">02 (stretch)</div>
  <div class="bg-color-pink-500 text-white p-4">03</div>
</div>
                `
            },
        },
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">justify-self-start</code>
                utility to align a grid item to the start of its inline axis.
            </p>
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">justify-self-end</code>
                utility to align a grid item to the end of its inline axis.
            </p>
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">justify-self-center</code>
                utility to center a grid item along its inline axis.
            </p>
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">justify-self-stretch</code>
                utility to stretch a grid item along its inline axis.
            </p>

            <div class="space-y-10">
                <div>
                    <small class="text-center block mb-4">justify-self-start</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 p-4 flex justify-center items-center rounded-lg">01</div>
                            <div class="bg-color-pink-500 p-4 flex justify-center items-center rounded-lg justify-self-start">02 (start)</div>
                            <div class="bg-color-pink-500 p-4 flex justify-center items-center rounded-lg">03</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">justify-self-end</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 p-4 flex justify-center items-center rounded-lg">01</div>
                            <div class="bg-color-pink-500 p-4 flex justify-center items-center rounded-lg justify-self-end">02 (end)</div>
                            <div class="bg-color-pink-500 p-4 flex justify-center items-center rounded-lg">03</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">justify-self-center</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 p-4 flex justify-center items-center rounded-lg">01</div>
                            <div class="bg-color-pink-500 p-4 flex justify-center items-center rounded-lg justify-self-center">02 (center)</div>
                            <div class="bg-color-pink-500 p-4 flex justify-center items-center rounded-lg">03</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">justify-self-stretch</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 p-4 flex justify-center items-center rounded-lg">01</div>
                            <div class="bg-color-pink-500 p-4 flex justify-center items-center rounded-lg justify-self-stretch">02 (stretch)</div>
                            <div class="bg-color-pink-500 p-4 flex justify-center items-center rounded-lg">03</div>
                        </div>
                    </div>
                </div>
            </div>
            `
        },
    ]
};

export default justifySelf;

<div className="sr-only">

    <div class="grid md:grid-columns-2 gap-10 space-y-10">
                <div>
                    <small class="text-center block mb-4">justify-self-start</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 p-4 rounded-lg">01</div>
                            <div class="bg-color-pink-500 p-4 rounded-lg justify-self-start">02 (start)</div>
                            <div class="bg-color-pink-500 p-4 rounded-lg">03</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">justify-self-end</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 p-4 rounded-lg">01</div>
                            <div class="bg-color-pink-500 p-4 rounded-lg justify-self-end">02 (end)</div>
                            <div class="bg-color-pink-500 p-4 rounded-lg">03</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">justify-self-center</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 p-4 rounded-lg">01</div>
                            <div class="bg-color-pink-500 p-4 rounded-lg justify-self-center">02 (center)</div>
                            <div class="bg-color-pink-500 p-4 rounded-lg">03</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">justify-self-stretch</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 p-4 rounded-lg">01</div>
                            <div class="bg-color-pink-500 p-4 rounded-lg justify-self-stretch">02 (stretch)</div>
                            <div class="bg-color-pink-500 p-4 rounded-lg">03</div>
                        </div>
                    </div>
                </div>
            </div>
</div>